import { render, staticRenderFns } from "./ddzd.vue?vue&type=template&id=13b4db9c"
import script from "./ddzd.vue?vue&type=script&lang=js"
export * from "./ddzd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports